// extracted by mini-css-extract-plugin
export default {"actions":"ConfirmDialog-actions___nLcGo","actions_wide":"ConfirmDialog-actions_wide___8P+sc","ok":"ConfirmDialog-ok___Dr3cB"};